export class FundClassArgs{
    web_Filing_Id : any
    user = ""
    timeStampCurrent : any
    revenue_type = ""
    measure = 0
    tax_period = ""
}